enum DataTest {
	'data-flow-details-table' = 'data-flow-details-table',
	'data-flow-details-row' = 'data-flow-details-row',
}

export default DataTest;
